import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useConfig } from '../context/ConfigContext';

export default function PrivacyPolicy() {
  const { contact } = useConfig();
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  return (
    <div className="bg-white">
      <Header/>
      <section className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">LEGAL</p>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900">Privacy Policy</h1>
        <p className="text-slate-500 mt-2">Effective {today}</p>
        <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
          <p>This Privacy Policy describes how <b>Xpertpests Solutions</b> (“XP-PRO”, “we”, “us”) collects, uses, and protects information when you use our field-service software, mobile applications, and customer portal (collectively, the “Service”).</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">1. Information We Collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><b>Account data</b>: name, email, phone, role (admin / technician / customer), encrypted password.</li>
            <li><b>Business data</b> you enter: customers, invoices, estimates, payments, work orders, leads, contracts, inventory, forms.</li>
            <li><b>Field data</b>: technician check-in/out times, GPS location while a job is in progress, service photos, customer signatures.</li>
            <li><b>Device data</b>: IP address, browser/device type, log timestamps (for security and diagnostics).</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">2. How We Use Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To operate, secure, and improve the Service.</li>
            <li>To send transactional emails / SMS related to your account, invoices, and service appointments.</li>
            <li>To comply with legal obligations (e.g. California CDPR pesticide application records).</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">3. Data Storage &amp; Security</h2>
          <p>Your data is stored in encrypted MongoDB instances. Passwords are hashed with bcrypt. API access requires JWT authentication. We do not sell your data to third parties.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">4. Sharing</h2>
          <p>We share data only (a) with service providers that help us run the Service (hosting, payment processing, SMS delivery), (b) when required by law, or (c) at your explicit direction (e.g. emailing an invoice to a customer).</p>
          <p><b>SMS/Text consent &amp; mobile data:</b> No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Information sharing to subcontractors in support services, such as our SMS delivery provider, is permitted only to operate the messaging program. All categories above exclude text-messaging originator opt-in data and consent; this information will not be shared with any third parties. See our <Link to="/sms-policy" className="text-[#8BC53F] font-semibold underline">SMS Messaging Terms &amp; Opt-In Policy</Link>.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">5. Your Rights</h2>
          <p>You may request export or deletion of your data at any time by emailing <a href={`mailto:${contact.email}`} className="text-[#8BC53F] font-semibold underline">{contact.email}</a>. California residents have additional rights under CCPA.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">6. Children</h2>
          <p>The Service is not directed to children under 13 and we do not knowingly collect data from them.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">7. Changes</h2>
          <p>We may update this policy. Material changes will be notified via email or an in-app banner.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">8. Contact</h2>
          <p>{contact.companyName}<br/>{contact.address}<br/>{contact.phone1} · {contact.phone2}<br/><a href={`mailto:${contact.email}`} className="text-[#8BC53F] font-semibold underline">{contact.email}</a></p>

          <div className="mt-10 pt-6 border-t border-slate-200 text-sm text-slate-500">
            See also our <Link to="/terms" className="text-[#8BC53F] font-semibold underline">Terms of Service</Link>.
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}
